// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront14 from "pages/Servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri/sections/sections/images/bgFront14.webp";
import bgBack14 from "pages/Servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri/sections/sections/images/bgBack14.webp";

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid
                    container
                    item
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ textAlign: "center" }}
                >
                    {/* ROTATING CARD */}
                    <Grid item xs={12} lg={4} sx={{ mx: "auto" }} spacing={2}>
                        <RotatingCard>
                            <RotatingCardFront
                                image={bgFront14}
                                icon="storefront"
                                title={
                                    <>
                                        Curățenie pentru
                                        <br />
                                        Centre de afaceri
                                    </>
                                }
                                description="Experiență, tehnologie și personal instruit – curățenie impecabilă pentru centre de afaceri"
                            />
                            <RotatingCardBack
                                image={bgBack14}
                                title="Calitate vizibilă, eficiență constantă"
                                description="Contactează-ne pentru o ofertă personalizată și consultanță gratuită."
                                action={{
                                    type: "internal",
                                    route: "/contact-curatenie",
                                    label: "cere o ofertă",
                                }}
                            />
                        </RotatingCard>
                    </Grid>

                    {/* 6 INFO CARDS */}
                    <Grid item xs={12} lg={7} sx={{ textAlign: "center" }} ml={6}>
                        <Grid
                            container
                            spacing={3}
                            sx={{ mt: { xs: 0, md: 6 } }}
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                        >
                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="home"
                                    title="Întreținere impecabilă"
                                    description="Asigurăm curățenie și îngrijire constantă a imobilului, fără a perturba activitățile desfășurate în interior sau exterior."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="people"
                                    title="Echipă instruită și prezentă"
                                    description="Personal bine pregătit, activ pe toată durata programului, gata să intervină rapid și discret ori de câte ori este nevoie."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="inventory"
                                    title="Fără grija logisticii"
                                    description="Tot ce ține de organizare și dotare e în grija noastră — dumneavoastră vă bucurați de rezultate, fără complicații."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="verified_user"
                                    title="Servicii asigurate"
                                    description="Garantăm calitate constantă, personal cu experiență, contracte clare și acoperire profesională în caz de daune."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="floor"
                                    title="Pardoseli tratate profesionist"
                                    description="Oferim curățare, igienizare, decapare și întreținere zilnică, adaptate oricărui tip de pardoseală și nivel de trafic."
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <DefaultInfoCard
                                    icon="miscellaneous_services"
                                    title="Servicii complementare & externalizare"
                                    description="Asigurăm curățarea fațadelor, geamurilor, firmelor luminoase, parcărilor, precum și externalizarea completă a personalului, pentru eficiență și control optim al costurilor."
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
